import { useEffect, useState } from "react";
import { api, API } from "../lib/api";
import { toast } from "sonner";
import SalaryCard, { salaryPeriod } from "../components/hris/SalaryCard";

export default function MySlips() {
  const [slips, setSlips] = useState([]);
  const [selected, setSelected] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    api.get("/my/slips").then(r => { setSlips(r.data); setSelected(r.data[0]?.id || ""); })
      .catch(e => setError(e?.response?.data?.detail || "Gagal memuat slip gaji"))
      .finally(() => setLoading(false));
  }, []);
  const slip = slips.find(s => s.id === selected);
  const download = async () => {
    try {
      const res = await fetch(`${API}/my/slip/${slip.id}/pdf`, { headers: { Authorization: `Bearer ${localStorage.getItem("hris_token")}` } });
      if (!res.ok) throw new Error("Gagal mengunduh slip gaji");
      const url = URL.createObjectURL(await res.blob()); const a = document.createElement("a");
      a.href = url; a.download = `SlipGaji_${slip.periode}.pdf`; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
    } catch (e) { toast.error(e.message); }
  };
  return <div className="salary-page">
    <header className="salary-page-title"><div><h1>Slip gaji saya</h1><p>Rincian penghasilan, dalam satu tempat.</p></div>{slips.length > 0 && <select aria-label="Periode slip gaji" value={selected} onChange={e => setSelected(e.target.value)}>{slips.map(s => <option key={s.id} value={s.id}>{salaryPeriod(s.periode)}</option>)}</select>}</header>
    {slip ? <div data-testid={`myslip-${slip.id}`}><SalaryCard key={slip.id} slip={slip} onDownload={download} downloadTestId={`btn-dl-${slip.id}`} /></div> : <div className="salary-state" role={error ? "alert" : "status"}><h2>{loading ? "Memuat slip gaji..." : error || "Belum ada slip gaji"}</h2>{!loading && !error && <p>Slip akan muncul setelah disiapkan oleh HR.</p>}</div>}
  </div>;
}
